import React from "react";

// Style \\
import "../../assets/styles/sections/heroAbout.scss";

const DoctorsHero = () => {
  return (
    <div>
      <section className="heroAbout">
        <div className="heroAbout_bg">
          <div className="container">
            <div className="hero_items">
              <div className="hero_items_title">
                <p>Home / Doctors</p>
                <h2>Our Doctors</h2>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default DoctorsHero;
